let ConsumeRoutes = [
  {
    // 工作时段设置
    path: '3101',
    name: '3101',
    component: () => import('@/pages/Consume/WorkTimeManage/WorkTimeManage')
  },
  {
    // 结算资料管理
    path: '3102',
    name: '3102',
    component: () => import('@/pages/Consume/MerchantSettlementManage/MerchantSettlementManage')
  },
  {
    // 单笔限额设置
    path: '3103',
    name: '3103',
    component: () => import('@/pages/Consume/MerchantSingleLimit/MerchantSingleLimit')
  },
  {
    // 福利应用设置
    path: '3201',
    name: '3201',
    component: () => import('@/pages/Consume/WelfareSetting/WelfareSetting')
  },
  {
    // 集体优惠设置
    path: '3202',
    name: '3202',
    component: () => import('@/pages/Consume/GroupDiscount/GroupDiscount')
  },
  {
    // 个人优惠设置
    path: '3203',
    name: '3203',
    component: () => import('@/pages/Consume/PersonDiscount/PersonDiscount')
  },
  {
    // 账户资料
    path: '3301',
    name: '3301',
    component: () => import('@/pages/Consume/AccountInfo/AccountInfo')
  },
  {
    // 补单
    path: '3302',
    name: '3302',
    component: () => import('@/pages/Consume/Supplement/Supplement')
  },
  {
    // 销户流水
    path: '3303',
    name: '3303',
    component: () => import('@/pages/Consume/CloseAccountRecordAndRefund/CloseAccountRecordAndRefund')
  },
  {
    // 预支充值
    path: '3401',
    name: '3401',
    component: () => import('@/pages/Consume/AdvanceRecharge/AdvanceRecharge')
  },
  {
    // 账户充值
    path: '3402',
    name: '3402',
    component: () => import('@/pages/Consume/AccountRecharge/AccountRecharge')
  },
  {
    // 现金充值
    path: '3403',
    name: '3403',
    component: () => import('@/pages/Consume/CashRecharge/CashRecharge')
  },
  {
    // 充值记录
    path: '3404',
    name: '3404',
    component: () => import('@/pages/Consume/RechargeRecord/RechargeRecord')
  },
  {
    // 补助金划拨
    path: '3405',
    name: '3405',
    component: () => import('@/pages/Consume/SubventionRecharge/SubventionRecharge')
  },
  {
    // 批量充值记录
    path: '3406',
    name: '3406',
    component: () => import('@/pages/Consume/BatchRechargeRecord/BatchRechargeRecord')
  },
  {
    // 外部码充值
    path: '3407',
    name: '3407',
    component: () => import('@/pages/Consume/ScanCodeRecharge/ScanCodeRecharge')
  },
  {
    // 手工退货
    path: '3501',
    name: '3501',
    component: () => import('@/pages/Consume/ConsumeRecord/ConsumeRecord')
  },
  {
    // 未取餐退款
    path: '3601',
    name: '3601',
    component: () => import('@/pages/Consume/DoNotTakeMealRefund/DoNotTakeMealRefund')
  },
  {
    // 收取工本费
    path: '3801',
    name: '3801',
    component: () => import('@/pages/Consume/CostOfProduction/CostOfProduction')
  },
  {
    // 异常查询
    path: '3802',
    name: '3802',
    component: () => import('@/pages/Consume/AbnormalManage/AbnormalManage')
  },
  {
    // 费用参数设置
    path: '3803',
    name: '3803',
    component: () => import('@/pages/Consume/FeeParam/FeeParam')
  },
  {
    // 费用记录查询
    path: '3804',
    name: '3804',
    component: () => import('@/pages/Consume/FeeRecord/FeeRecord')
  },
  {
    // 分户流水
    path: '4500',
    name: '4500',
    component: () => import('@/pages/Consume/SubAccountRecord/SubAccountRecord')
  },
  {
    // 交易流水
    path: '4510',
    name: '4510',
    component: () => import('@/pages/Consume/TransactionRecord/TransactionRecord')
  },
  {
    // 非终端交易(账户交易)流水
    path: '4520',
    name: '4520',
    component: () => import('@/pages/Consume/AccTransRecord/AccTransRecord')
  },
  {
    // 个人账户流水
    path: '4530',
    name: '4530',
    component: () => import('@/pages/Consume/AccountTransRecord/AccountTransRecord')
  },
  {
    // 个人交易流水
    path: '4540',
    name: '4540',
    component: () => import('@/pages/Consume/PersonalConsumeRecord/PersonalConsumeRecord')
  },
  {
    // 人员时段限额
    path: '4202',
    name: '4202',
    component: () => import('@/pages/Consume/ConsumeQuotaOfWorkTime/ConsumeQuotaOfWorkTime')
  },
  {
    // 人员每日限额
    path: '4203',
    name: '4203',
    component: () => import('@/pages/Consume/ConsumeQuotaOfDay/ConsumeQuotaOfDay')
  },
  {
    // 人员计次消费
    path: '4204',
    name: '4204',
    component: () => import('@/pages/Consume/CountConsume/CountConsume')
  },
  {
    // 人员类别定额消费
    path: '4205',
    name: '4205',
    component: () => import('@/pages/Consume/PersonSortsQuotaConsume/PersonSortsQuotaConsume')
  },
  {
    // 消费终端资料
    path: '4301',
    name: '4301',
    component: () => import('@/pages/Consume/PosTermManage/PosTermManage')
  },
  {
    // 终端个性化设置
    path: '4302',
    name: '4302',
    component: () => import('@/pages/Consume/PosTermAttribute/PosTermAttribute')
  },
  {
    // 工作参数设置
    path: '4303',
    name: '4303',
    component: () => import('@/pages/Consume/PosParameter/PosParameter')
  },
  {
    // 就餐登记统计
    path: '3701',
    name: '3701',
    component: () => import('@/pages/Consume/MealsRegister/MealsRegister')
  },
  {
    // 就餐登记明细
    path: '3702',
    name: '3702',
    component: () => import('@/pages/Consume/MealsRegister/MealsRegisterDetails')
  },
  {
    path: '000',
    name: '',
    component: () => import('@/pages/Consume/component/camera_test2')
  },
  {
    path: '001',
    name: '',
    component: () => import('@/pages/Consume/component/cardTest')
  }
]

export {
  ConsumeRoutes
}



// WEBPACK FOOTER //
// ./src/router/ConsumeRoutes.js